import { LocationAddress, Location, LocationsShow } from '../types';

export const getFullAddress = (options: LocationAddress) =>
  [
    options.address,
    options.entrance && `${options.entrance} подъезд`,
    options.floor && `${options.floor} этаж`,
    options.apartments && `кв ${options.apartments}`,
    options.doorPhone && `домофон: ${options.doorPhone}`,
  ]
    .filter(Boolean)
    .join(', ');

export const getLocationHash = (location: Location) => {
  const hashFields: (keyof Location)[] = [
    'title',
    'latitude',
    'longitude',
    'address',
    'entrance',
    'floor',
    'apartments',
    'doorPhone',
    'note',
  ];
  return hashFields.map((field) => location[field]).join(':');
};

export const filterDuplicatedLocations = (locations: LocationsShow[]) => {
  const hashToUuid: Record<string, true> = {};

  const result: LocationsShow[] = [];
  locations.forEach((location) => {
    const hash = getLocationHash(location);
    if (hash in hashToUuid) return;

    hashToUuid[hash] = true;
    result.push(location);
  });

  return result;
};
